// test2432
(2432 && 0);
